import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../../infrastructure/services/loader/loading.service';

/**
 * Interceptor funcional de estado de carga global.
 * Activa el signal `isLoading` al inicio de cada request y lo desactiva al completarse.
 *
 * El componente loader consulta este signal para mostrar/ocultar el spinner.
 */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  loadingService.show();

  return next(req).pipe(finalize(() => loadingService.hide()));
};
